import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { getContentKeyAccToLang, showToast } from '../../../utils/utils';
import { RowView, Text } from '../../CorporateForm/components';
import Button from '../../../components/Button';
import icons from '../../../constants/icons';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import { logoutUser } from '../../../store/actions/authActions';
import {
  getIndApplicationStatus,
  submitIndApplication,
  submitIndKycApplication
} from '../../../store/actions/individualAction';

const navItems = [
  {
    label: 'personal_information',
    path: '/personal-information',
    name: 'personalinformation',
  },
  {
    label: 'contact_information',
    path: '/contact-information',
    name: 'contactinformation',
  },
  {
    label: 'employer_information',
    path: '/employer-information',
    name: 'ProfessionalInformation',
  },
  {
    label: 'general_information',
    path: '/general-information',
    name: 'generalinformation',
  },
  {
    label: 'bank_custodian_information',
    path: '/bank-custodian-information',
    name: 'BankAndCustodianInformation',
  },
  {
    label: 'investment_portfolio',
    path: '/investment-portfolio',
    name: 'investmentportfolio',
  },
  {
    label: 'client_classification',
    path: '/client-classification',
    name: 'clientclassification',
  },
  // {
  //   label: 'special_cases',
  //   path: '/special-cases',
  //   name: 'specialcasesd',
  // },
  {
    label: 'tax_declaration',
    path: '/tax-declaration',
    name: 'taxdeclaration',
  },
  {
    label: 'document_vault',
    path: '/document-vault',
    name: 'documentvault',
  },
];

const SubmitApplication = ({ setStep }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isArabic, TextWeight } = dynamicfunction();

  const { individualContent } = useSelector((state) => state.content);

  const { individualLoading, ind_post_loading, ind_application_status } = useSelector((state) => state.individual);

  const { client_application_id, is_kyc } = useSelector((state) => state.constant);

  useEffect(() => {
    getData()
  }, []);

  const getData = async () => {
    await dispatch(getIndApplicationStatus(client_application_id));
  }

  const handleSubmit = async () => {
    const api_data = {
      clientApplicantId: client_application_id,
    };
    is_kyc
      ? dispatch(
        submitIndKycApplication({ clientApplicantId: client_application_id }, (res) => {
          showToast({
            icon: 'success',
            title: res?.result?.responseMessage ?? '',
          });
          navigate('/funds/available-funds');
        }),
      )
      : dispatch(
        submitIndApplication({ clientApplicantId: client_application_id }, (res) => {
          showToast({
            icon: 'success',
            title: res?.message ?? '',
          });
          dispatch(logoutUser());
        }),
      );
  };

  const getContent = (key) => {
    return getContentKeyAccToLang(individualContent?.individual_account_opening?.data?.attributes, key, isArabic);
  };

  return (
    <>
      {!individualLoading && (
        <>
          {/* <RowView isResponsive className='flex-wrap'>
            {navItems.map((item, index) => {
              return (
                <RowView key={index} className='gap-4 items-center w-1/2 mb-4 cursor-pointer' onClick={() => setStep(index)}>
                  <ReactSVG src={icons.success_icon} />
                  <div>
                    <Text text={getContent(item?.label)} className='block' weight={TextWeight.medium} isTruncate={false} />
                    <Text text={getContent('click_to_review')} className='text-primary block' size={fontSizes.h14} />
                  </div>
                </RowView>
              );
            })}
          </RowView> */}

          <RowView isResponsive className='flex-wrap'>
            {navItems.map((item, index) => {
              const isCompleted = is_kyc ? true : (ind_application_status?.length > 0
                ? ind_application_status?.find(
                  (s) =>
                    s?.sectionName?.toLowerCase() === item?.name.toLowerCase()
                )?.isCompleted
                : false);
              return (
                <RowView
                  key={index}
                  className='gap-4 items-center w-1/2 mb-4 cursor-pointer'
                  onClick={() => setStep(index)}
                >
                  <ReactSVG
                    src={
                      isCompleted || item?.isCompleted
                        ? icons.success_icon
                        : icons?.null_icon
                    }
                  />
                  <div>
                    <Text
                      text={getContent(item?.label)}
                      className='block'
                      weight={TextWeight.medium}
                      isTruncate={false}
                    />
                    <Text
                      text={getContent('click_to_review')}
                      className='text-primary block'
                      size={fontSizes.h14}

                    />
                  </div>
                </RowView>
              );
            })}
          </RowView>


          <RowView className='mt-4'>
            <Button
              text={getContent('submit')}
              color={'text-white hover:text-primary '}
              bgColor='bg-primary hover:bg-transparent hover:border-primary'
              className={'border border-transparent w-44 px-0 text-center'}
              onClick={handleSubmit}
              isDisabled={ind_post_loading}
              loading={ind_post_loading}
            />
          </RowView>
        </>
      )}
    </>
  );
};

export default SubmitApplication;
